// <customize-designer-cta>: wires its button to the JAM designer. A custom element so it re-upgrades
// when the PDP lazy-switch replaces this section's innerHTML.
class CustomizeDesignerCta extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-customize-designer]');
    this.button?.addEventListener('click', this.open);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.open);
  }

  open = () => {
    if (typeof window.JamDesigner?.open !== 'function') return;
    window.JamDesigner.open({
      productDesignKey: this.button.dataset.designKey || '',
      qty: Number(this.button.dataset.designQty) || 1,
    });
  };
}

if (!customElements.get('customize-designer-cta')) {
  customElements.define('customize-designer-cta', CustomizeDesignerCta);
}
